import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { ApolloResponse } from '@/interfaces/apollo'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { AccountAsset } from '@/modules/AccountAsset/interfaces/account-asset'
import { showErrors } from '@/utils/snack'
import { dateTimeToDisplay, dateToNow } from '@/utils/dateTime'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppSearch from '@/components/AppSearch.vue'
import AppRefresh from '@/components/AppRefresh.vue'
import AppTabs from '@/components/AppTabs.vue'
import AccountAssetDetailDetail from '@/modules/AccountAsset/views/property-detail.vue'
import { getAccountAsset } from '@/modules/AccountAsset/gql/account-asset.gql'
import AssetPropertyDialog from '@/modules/AccountAsset/scripts/asset-property-dialog'

@Component({
  components: {
    AppBreadcrumbs,
    AppSearch,
    AppRefresh,
    AppTabs,
    AccountAssetDetailDetail
  }
})
export default class AccountAssetDetail extends mixins(AssetPropertyDialog) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Client Information'
    },
    {
      text: 'Accounts',
      to: { name: 'AccountsList' }
    }
  ]

  accountAssetName = ''

  accountAsset: AccountAsset | null = null

  windowSize = {
    w: 0,
    h: 0,
    cW: 0
  }

  tabActive = 0
  tabItems = [
    { title: 'Details', route: 'AccountAssetPropertyDetailDetail' },
    {
      title: 'Document', route: 'AccountAssetPropertyDetailDocument'
    }
  ]

  dateTimeToDisplay = dateTimeToDisplay
  dateToNow = dateToNow

  get tabTitles () {
    return this.tabItems.map(item => item.title)
  }

  async mounted () {
    const { name } = this.$route
    const index = this.$R.findIndex((item: any) => item.route === name)(this.tabItems)
    this.tabActive = index
    this.onResize()
    this.getAccountAsset()
  }

  onResize () {
    const container = this.$refs.container as Vue & { clientWidth: number }
    this.windowSize = { w: window.innerWidth, h: window.innerHeight, cW: container.clientWidth }
  }

  clickTabHandler (index: number) {
    const item = this.tabItems[index]
    if (item.route && item.route !== this.$route.name) {
      this.$router.push({
        name: item.route
      })
    }
  }

  async getAccountAsset () {
    const accountAssetId = Number(this.$route.params.id)
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getAccountAsset,
        variables: {
          accountAssetId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      const accountAsset = result.data.getAccountAsset as AccountAsset

      if (this.breadcrumbs.length === 2) {
        this.breadcrumbs.push({
          text: accountAsset.account.name,
          to: {
            name: 'AccountDetailAssets',
            params: {
              id: accountAsset.account.id
            }
          }
        })
        this.breadcrumbs.push({
          text: 'Property'
        })
        this.breadcrumbs.push({
          text: accountAsset.name
        })
      }

      this.accountAsset = accountAsset
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async deletePropertyConfirm () {
    if (!this.accountAsset) {
      return
    }
    await this.deletePropertyPost()
    this.$router.replace({
      name: 'AccountDetailAssets',
      params: {
        id: this.accountAsset.account.id + ''
      }
    })
  }
}
